import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import { MdCreate } from "react-icons/md";
import { DisplaySpinnerContext, TabPanelContext } from "../../../../context/ContextIndex";
import DataGridRange from "../../../../components-old/elements/DataGridRange/DataGridRange";
import GridAction from "../../../../components-old/elements/GridAction/GridAction";
import ButtonGroup from "../../../../components-old/elements/ButtonGroup/ButtonGroup";
import { Checkbox } from "@mui/material";
import { IsLoggedInUserViewer } from "../../../../hoc/withAuthRedirect";
import { notifyToast, ToastType } from "../../../../components-old/ComponentsIndex";

const PezodeRangeList = ({ onAddClick, setShowForm, setIsFormValid }) => {
    const _tabContextObject = useContext(TabPanelContext);
    const _tabContext = _tabContextObject.getTabFormContext();

    const spinnerCtx = useContext(DisplaySpinnerContext);

    const { t } = useTranslation();

    const [pezodeRangeRecordList, setPezodeRangeRecordList] = useState([]);
    const [dataGridPageSize, setDataGridPageSize] = useState(10);
    const [totalPezodeRange, setTotalPezodeRange] = useState(0);
    const [gridPageSizeOptions] = useState([10, 20, 50]);

    // Set pezode range after fetching or directly for non-edit cases
    const setPezodeRangeList = (pezodeRangeList) => {
        const sortedList = [...pezodeRangeList].sort((a, b) => a.MininumInputValue - b.MininumInputValue);

        const updatedList = sortedList.map((item, index) => ({
            id: index,
            PezodeRangeId: item.PezodeRangeId,
            MininumInputValue: item.MininumInputValue,
            MaximumInputValue: item.MaximumInputValue,
            OutputUnit: item?.OutputUnit?.label,
            OutputUnitValue: item.OutputUnitValue,
            OutputValue: item.OutputValue,
            Summation: item.Summation,
            recordResponse: { ...item, Deleted: false },
            deleted: false,
        }));

        setPezodeRangeRecordList(updatedList);
        setTotalPezodeRange(updatedList.length);
        spinnerCtx.setLoadingIndicator(false);
    };

    useEffect(() => {
        const pezoderange = _tabContext.data?.pezoderange || [];
        if (pezoderange.length > 0) {
            setPezodeRangeList(pezoderange);
            setIsFormValid(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEditPezodeRangeClick = (data) => {
        _tabContextObject.setTabFormContext({
            data: {
                ..._tabContext.data,
                selectedPezodeRange: data.recordResponse,
            },
        });

        setShowForm(true);
    };

    const handleDeletePezodeRange = (data, selectionStatus) => {
        try {
            const _gridRecordList = pezodeRangeRecordList.map(item => {
                if (item.id === data.id) {
                    return {
                        ...item,
                        deleted: selectionStatus,
                        recordResponse: {
                            ...item.recordResponse,
                            Deleted: selectionStatus,
                        },
                    };
                }
                return item;
            });

            const _prezodeRangeList = _gridRecordList.map(item => {
                return item.recordResponse;
            });

            setPezodeRangeRecordList(_gridRecordList);
            // Check if at least one record has deleted set to false
            const hasActiveRecords = _gridRecordList.some(item => !item.deleted);
            if (!hasActiveRecords) {
                notifyToast("Pezode Range is mandatory", ToastType.ERROR);
            }
            setIsFormValid(hasActiveRecords);
            _tabContextObject.setTabFormContext({
                data: {
                    ..._tabContext.data,
                    pezoderange: _prezodeRangeList,
                },
                isValid: hasActiveRecords
            });

        } catch (err) {
            alert(err);
        }
    };

    const handlePageSizeChange = (newPageSize) => {
        setDataGridPageSize(newPageSize);
    };

    const actionConfigs = [
        {
            icon: MdCreate,
            onClick: handleEditPezodeRangeClick,
            buttonColor: "#EEEEE",
            action: "edit",
        },
    ];

    const buttonConfigs = [
        {
            buttonText: <AddIcon />,
            buttonType: "filled",
            onClick: onAddClick,
            buttonColor: "#A62B23",
            textColor: "#fff",
            action: "create",
        },
    ];

    const dataGridSchema = [
        {
            field: "MininumInputValue",
            headerName: t("pezodeRangeList.minInputValue"),
            flex: 1,
        },
        {
            field: "MaximumInputValue",
            headerName: t("pezodeRangeList.maxInputValue"),
            flex: 1,
        },
        {
            field: "OutputUnitValue",
            headerName: t("pezodeRangeList.outputUnitValue"),
            flex: 1,
        },
        {
            field: "OutputValue",
            headerName: t("pezodeRangeList.outputValue"),
            flex: 1,
        },
        {
            field: "OutputUnit",
            headerName: t("pezodeRangeList.outputUnit"),
            flex: 1,
        },
        {
            field: "Summation",
            headerName: t("pezodeRangeList.summation"),
            flex: 1,
        },
        !IsLoggedInUserViewer() && {
            field: "deleted",
            headerName: "Mark for Delete",
            flex: 1,
            sortable: false,
            renderCell: (params) => (
                <Checkbox defaultChecked={false} onChange={(e) => handleDeletePezodeRange(params.row, e.target.checked)} />
            ),
        },
        {
            field: "action",
            headerName: t,
            flex: 1,
            sortable: false,
            renderCell: (params) => <GridAction actionsConfig={actionConfigs} row={params.row} />,
        },
    ];

    return (
        <>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ fontWeight: "bold", height: "30px" }}>{t("pezodeRangeList.header")}</div>
                <ButtonGroup buttons={buttonConfigs} />
            </div>

            <DataGridRange
                rows={pezodeRangeRecordList}
                columns={dataGridSchema}
                pageSize={dataGridPageSize}
                pageSizeOptions={gridPageSizeOptions}
                onPageSizeChange={handlePageSizeChange}
                totalRowCount={totalPezodeRange}
                toolbarHeader=""
                toolbarFilterPlaceholder={t("quoteApproval.toolbarFilterPlaceholder")}
            />
        </>
    );
};

export default PezodeRangeList;
